require("./wdh-legacy/cookies/js/base/component-cookies.js");